import { groupBy, map } from 'lodash'
import { convertNumber } from 'utils'

function summarizeParticipantsDataByPlanTaxableAccounts(participantsData) {
  const participantsHash = groupBy(
    participantsData,
    (participant) => participant.mappedPlanName || participant.planName
  )

  return map(participantsHash, (records, planName) => {
    return {
      planName,
      participants: records.length,
      ['taxableAmount']: sumUpRecordsAccount(records, 'taxableAmount'),
    }
  })
}

// ----- PRIVATE -----

const sumUpRecordsAccount = (records, accountType) => {
  return records.reduce(
    (total, record) => total + convertNumber(record[accountType]),
    0
  )
}

export default summarizeParticipantsDataByPlanTaxableAccounts
